import { WEBVIEW_USER_AGENT } from '../../constants/mobile-app/user-agent';
const isMobileApp = () => typeof navigator !== 'undefined' && navigator?.userAgent === WEBVIEW_USER_AGENT || typeof window !== 'undefined' && window?.isUpgradeNativeApp === true;
export default isMobileApp;